import { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import StoreStyle from '../../../assets/stylesheets/store/StorePage.module.css';
import StoreCardList from "../StoreCardList";

import Strawberry from '../../../assets/img/sample/Strawberry Preserves.jpg';
import Mozzarella from '../../../assets/img/sample/Fresh Mozzarella.jpg';
import Broccoli from '../../../assets/img/sample/Broccoli Crowns.jpg';
import Mushrooms from '../../../assets/img/sample/Cremini Mushrooms.jpg';
import Onion from '../../../assets/img/sample/Onion.jpg';
import Potatoes from '../../../assets/img/sample/Potatoes.jpg';

// Popular items data (updated to match images)
const POPULAR_ITEMS = [
  { id: 'pop-1', name: 'Strawberry Preserves',     price: '$5.99/12oz',  info: 'Small-batch • Classic spread', img: Strawberry },
  { id: 'pop-2', name: 'Fresh Mozzarella',         price: '$6.99/8oz',   info: 'Creamy • Hand-packed',          img: Mozzarella },
  { id: 'pop-3', name: 'Broccoli Crowns',          price: '$2.49/lb',    info: 'Tender florets • Fresh cut',    img: Broccoli },
  { id: 'pop-4', name: 'Cremini Mushrooms',        price: '$3.79/lb',    info: 'Firm texture • Earthy flavor',  img: Mushrooms },
  { id: 'pop-5', name: 'Sweet Onions',             price: '$1.29/lb',    info: 'Mild & sweet • Great for roasting', img: Onion },
  { id: 'pop-6', name: 'Yukon Gold Potatoes',      price: '$1.49/lb',    info: 'Buttery • Creamy texture',      img: Potatoes },
];

export default function PopularItems({ title = 'Popular items', to }) {
  const LIMIT = 6;
  const [loading, setLoading] = useState(true);

  // simulate async loading for demo purposes
  useEffect(() => {
    const t = setTimeout(() => setLoading(false), 300);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className={StoreStyle['featured-section']}>
      <div className={StoreStyle['featured-header']}>
        <h2 style={{ fontSize: 22, margin: 0 }}>{title}</h2>
        {to ? <Link to={to} style={{ color: '#16a34a', fontWeight: 600 }}>See all</Link> : null}
      </div>

      {/* Simple wrapper without external arrows */}
      <div className={StoreStyle['swiper-rail']}>
        <StoreCardList
          items={POPULAR_ITEMS}
          loading={loading}
          onBuy={(item) => {
            // placeholder action for demo
            // eslint-disable-next-line no-console
            console.log('Buy clicked:', item);
          }}
          skeletonCount={LIMIT}
        />
      </div>
    </section>
  );
}

